import { ImportStockStore } from './stock-in-store-import.component';

export default ImportStockStore;
